module.exports = {"id":"dp3_3l1q2","text":"Copyright and licences","instructions":"Which statement best reflects how copyright applies online?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.3","questionType":"PickOne","random":true,"options":[{"id":"dp3_3l1q2-a1","text":"Permission may still be required","score":1.8},{"id":"dp3_3l1q2-a2","text":"Online content is always free","score":0},{"id":"dp3_3l1q2-a3","text":"Copyright rarely applies online","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.3/l1q2.json
// module id = 1156
// module chunks = 41